<template>
  <div class="content">
    <div class="box">
      <div class="error-text">404 | NOT FOUND</div>
      <el-button @click="onHome">返回首页</el-button>
      <el-button @click="onBack">返回上一页</el-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onHome() {
      this.$router.push({ path: "/" }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  height: 100%;
}
.box {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .error-text {
    color: #afb1b6;
    margin-bottom: 36px;
  }
  .el-button + .el-button {
    margin-left: 0;
    margin-top: 20px;
  }
}
</style>
